const BYTES_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'] as const;

export interface FormatBytesOptions {
  /**
   * Custom fallback label when the input is null, undefined, or not a finite number.
   * Defaults to '0 B'.
   */
  fallback?: string;
}

/**
 * Format a byte count using binary (1024) units with compact suffixes.
 * Values >= 10 in a given unit are rounded to the nearest integer; smaller values keep one decimal.
 */
export function formatBytes(value: number | null | undefined, { fallback = '0 B' }: FormatBytesOptions = {}): string {
  if (value === null || value === undefined || !Number.isFinite(value) || value <= 0) {
    return fallback;
  }

  let remaining = Math.abs(value);
  let unitIndex = 0;

  while (remaining >= 1024 && unitIndex < BYTES_UNITS.length - 1) {
    remaining /= 1024;
    unitIndex += 1;
  }

  const precision = remaining >= 10 || unitIndex === 0 ? 0 : 1;
  const formatted = Number(remaining.toFixed(precision)).toString();
  const label = BYTES_UNITS[unitIndex];

  return `${formatted} ${label}`;
}
